
import { CheckboxProps } from "./checkbox.props";
import { CheckboxContainer } from "./checkbox.styled";

const AGCheckbox: React.FC<CheckboxProps> = ({ value, isRadioButton = false, disabled = false, onChange,classNameCus, ...props }) => {

    return (
        <CheckboxContainer className={`container ${classNameCus}`} isRadioButton = {isRadioButton} disabled = {disabled}>
            <input onChange={onChange} checked={value?.toString()?.toLowerCase() === "true" ? true : false} value={value} disabled = {disabled} type="checkbox" {...props} />
            <span className="checkmark"></span>
        </CheckboxContainer>
    );
};

export default AGCheckbox;



